import { Injector, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { BaseCalss } from '../classes/base-config.class';
import { Observable } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';

@Injectable()
export class BaseService {
    protected http: HttpClient;
    httpOptions: any = {};
    conf = new BaseCalss();
    params: HttpParams;

    get appEnv() {
        return this.conf.env;
    }

    get apiUrl() {
        return this.conf.baseApiUrl;
    }

    get appBase() {
        return this.conf.baseHost;
    }

    get getResultAppBase() {
        return this.conf.resultAppBase;
    }

    get getWPAppBase() {
        return this.conf.wpAppBase;
    }

    get getDomain() {
      return this.conf.domain;
  }

    get getPaymentAppBase(){
        return this.conf.paymentAppBase;
    }

    get fbAppId() {
        return this.conf.fbAppId
    }

    get imageUrl() {
        return this.conf.imageBaseUrl;
    }

    get newAppBase(){
      return this.conf.newAppBase;
    }

    constructor(injector: Injector) {
        this.params = new HttpParams();
        this.http = injector.get(HttpClient);
        let header: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.httpOptions = {
            headers: header,
            withCredentials: true
        };
    }

    postFile(fileToUpload: File, filePath) {
        let headers = new HttpHeaders();
        headers.append(
            'Content-Type',
            'application/x-www-form-urlencoded; charset=UTF-8'
        );
        headers.append('Access-Control-Allow-Headers', 'session-variable');
        headers.append('Access-Control-Allow-Methods', 'POST, OPTIONS');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Access-Control-Allow-Credentials', 'true');

        const endpoint = `${this.apiUrl}upload?path=${filePath}`;
        const formData: FormData = new FormData();
        formData.append('fileKey', fileToUpload, fileToUpload.name);
        return this.http.post(endpoint, formData, { headers: headers });
    }

    uploadFiles(formFiles: FormData, path) {
        let headers = new HttpHeaders();
        headers.append(
            'Content-Type',
            'application/x-www-form-urlencoded; charset=UTF-8'
        );
        headers.append('Access-Control-Allow-Headers', 'session-variable');
        headers.append('Access-Control-Allow-Methods', 'POST, OPTIONS');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Access-Control-Allow-Credentials', 'true');

        const endpoint = `${this.apiUrl}upload-files?path=${path}`;

        return this.http.post(endpoint, formFiles, { headers: headers });
    }

    saveClientError(data) {
        return this.http.post(`${this.apiUrl}/dev/save-error`, JSON.stringify(data), this.httpOptions)
    }

    getAvailableGameAndPlay(club_id) {
        return this.http.get(`${this.apiUrl}/public/club/game/status?club_id=${club_id}`, this.httpOptions);
    }

    getClubSearched(terms: Observable<string>, pageNo: number, itemsPerPage: number) {
        return terms.pipe(
            debounceTime(1000),
            switchMap(term => this.getClubsDropdown(term, pageNo, itemsPerPage))
        );
    }

    getClubsDropdown(club_name, pageNo, itemsPerPage) {
        let params = new HttpParams();
        if (club_name && club_name != '' && club_name.length > 0)
            params = params.append('name', club_name);

        if (pageNo && pageNo != '')
            params = params.append('pageNo', pageNo);

        if (itemsPerPage && itemsPerPage != '')
            params = params.append('itemsPerPage', itemsPerPage);

        this.httpOptions['params'] = params;
        return this.http.get(`${this.apiUrl}public/by-name-county-code`, this.httpOptions);
    }

    sendResponseInSlack(data) {
        return this.http.post(`${this.apiUrl}public/client-logging/send-to-slack`, JSON.stringify(data), this.httpOptions);
    }

    redirectToLogin(incomingFrom = '',params='') {
      //console.log('redirectToLogin', incomingFrom, params);
      window.location.href = `${this.newAppBase}auth/login${params}`;
    }

    redirectToRegister(incomingFrom = '', params='') {
      window.location.href = `${this.newAppBase}auth/register${params}`;
    }

    redirectToNewApp(route ='', params=''){
      window.location.href = `${this.newAppBase}${route}${params}`;
    }
}
